import { ListItemButton, Menu, styled } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import ReactToPrint from "react-to-print";
import React, { forwardRef } from "react";

export const ExportContainer = styled("div")({
  // width: '240px',
  direction: "rtl",
  display: "flex",
  flexDirection: "column",
  // height: '144px',
  // padding: '16px 12px',
  justifyContent: "space-between",
});

export const Item = styled(ListItemButton)(({ theme }) => ({
  height: "40px",
  borderRadius: "4px",
  width: "100%",
}));

export const StyledListItemText = styled("div")({
  textAlign: "right",
  fontSize: "12px",
  marginRight: "8px",
});
export const StyledListItemIcon = styled("div")({
  // minWidth: '30px'
});

const ExportBotton = forwardRef(
  (
    {
      anchorEl,
      handleClose,
      downloadTable,
    }: {
      anchorEl: null | HTMLElement;
      handleClose: () => void;
      downloadTable: (type: String) => void;
    },
    ref: any
  ) => {
    const open = Boolean(anchorEl);

    return (
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        sx={{
          left: "35px",
          "& div": {
            "& ul": {
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
        }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <ExportContainer>
          <Item disableRipple onClick={() => downloadTable("excel")}>
            <StyledListItemIcon>
              <SnippetFolderIcon color="success" />
            </StyledListItemIcon>
            <StyledListItemText>Excel</StyledListItemText>
          </Item>
          <Item disableRipple>
            <ReactToPrint
              trigger={() => (
                <div style={{ display: "flex" }}>
                  <StyledListItemIcon>
                    <PictureAsPdfIcon color="error" />
                  </StyledListItemIcon>
                  <StyledListItemText>PDF</StyledListItemText>
                </div>
              )}
              content={() => ref.current}
            />
          </Item>
        </ExportContainer>
      </Menu>
    );
  }
);

export default ExportBotton;
